import ISettingDetail from '@Shared.Angular/@types/core/contracts/config/ISettingDetail';
import ICategoryDetail from '@Shared.Angular/@types/core/contracts/queryModel/category/categoryDetail';
import ITeamsResultModel from '@Shared.Angular/@types/core/contracts/queryModel/team/teamsResultModel';
import ISearchUserResultModel from '@Shared.Angular/@types/core/contracts/queryModel/user/searchUserResultModel';
import ICustomTableName from '@Shared.Angular/@types/customDb/services/models/customTableName';
import { sortCategoriesNaturally } from '@Shared.Angular/flowingly.helper/naturalSort';
import { Services } from '@Shared.Angular/@types/services';
import { IHttpService } from 'angular';

/**
 * @ngdoc service
 * @name setupApiService
 * @module flowingly.services
 *
 * @description A service responsible solely for fetching data in setup page
 */

export default class SetupApiService {
  constructor(
    private $http: angular.IHttpService,
    private APP_CONFIG: Services.APP_CONFIG,
    private lodashService: Lodash,
    private teamApiService: Services.TeamApiService
  ) {}

  public cachedCategories: ICategoryDetail[];
  service = {
    databases: [] as ICustomTableName[],
    teams: [],
    users: []
  };

  getCategories(noSpinner = false) {
    return this.$http
      .get<ICategoryDetail[]>(
        this.APP_CONFIG.apiBaseUrl + 'setup/categories',
        {
          noSpinner: noSpinner || false
        }
      )
      .then((response) => {
        const sortedCategories = sortCategoriesNaturally(response.data);

        this.cachedCategories = angular.copy(sortedCategories);
        return sortedCategories;
      });
  }

  getDatabases(noSpinner) {
    return this.$http
      .get<ICustomTableName[]>(`${this.APP_CONFIG.apiBaseUrl}setup/databases`, {
        noSpinner: noSpinner || false
      })
      .then((response) => {
        angular.copy(response.data, this.service.databases);
        this.sortDatabasesByName();
        return response.data;
      });
  }

  sortDatabasesByName() {
    this.service.databases.sort((t1, t2) => {
      const t1NameToCompare = t1.name.trim().toLowerCase();
      const t2NameToCompare = t2.name.trim().toLowerCase();

      if (t1NameToCompare < t2NameToCompare) {
        return -1;
      }

      if (t1NameToCompare > t2NameToCompare) {
        return 1;
      }

      return 0;
    });
  }

  getTeamsWithOptions(options: any): angular.IPromise<ITeamsResultModel> {
    return this.teamApiService.getTeamsWithOptions(options).then((response) => {
      angular.copy(response.teams, this.service.teams);
      return response;
    });
  }

  getUsersWithOptions(options) {
    const defaultOpts = {
      take: 100,
      skip: 0,
      page: 1,
      pageSize: 100,
      group: []
    };
    options = this.lodashService.defaults(options, defaultOpts);
    return this.$http
      .post<ISearchUserResultModel>(
        this.APP_CONFIG.apiBaseUrl + 'setup/users',
        options
      )
      .then((response) => {
        angular.copy(response.data.users, this.service.users);
        return response.data;
      });
  }

  public getFeature(featureName: string) {
    return this.$http
      .get<ISettingDetail>(
        `${this.APP_CONFIG.apiBaseUrl}setup/features/${featureName}`
      )
      .then((response) => {
        return response.data;
      });
  }
}
angular
  .module('flowingly.services')
  .factory('setupApiService', [
    '$http',
    'APP_CONFIG',
    'lodashService',
    'teamApiService',
    (
      $http: IHttpService,
      APP_CONFIG: Services.APP_CONFIG,
      lodashService: Lodash,
      teamApiService: Services.TeamApiService
    ) => new SetupApiService($http, APP_CONFIG, lodashService, teamApiService)
  ]);
export type SetupApiServiceType = InstanceType<typeof SetupApiService>;
